'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGiftaEngagementsRate = exports.getJLEngagementsRate = exports.getEngagementsRate = exports.getPostTypes = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

var _asaCompliance = require('./../../utils/asa-compliance');

var _asaCompliance2 = _interopRequireDefault(_asaCompliance);

var _colors = require('./../../utils/colors');

var _formatting = require('./../../utils/formatting');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var paddingTopTen = {
  margin: 0
};

var igValueStyle = {
  fontSize: 20,
  color: _colors.dyzioPalette.pink,
  fontWeight: 'bold',
  padding: 5
};

var gridStyle = {
  fontSize: 16,
  color: 'gray'
};

var IGValue = function IGValue(_ref) {
  var value = _ref.value;
  return _react2.default.createElement(
    'div',
    { style: igValueStyle },
    value
  );
};

IGValue.propTypes = {
  value: _propTypes2.default.string.isRequired
};

var InfluencerPost = function InfluencerPost(props) {
  var post = props.post;

  if (!post || !post.trackedAsset || !post.trackedAsset.assetURL) return null;

  var isASA = (0, _asaCompliance2.default)(post.text);

  return _react2.default.createElement(
    _semanticUiReact.Grid.Column,
    { textAlign: 'center' },
    _react2.default.createElement(
      'a',
      { href: post.trackedAsset.assetURL, rel: 'noopener noreferrer', target: '_blank' },
      _react2.default.createElement(_semanticUiReact.Image, { src: post.thumbnail, size: 'tiny', fluid: true }),
      isASA && _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(_semanticUiReact.Label, { size: 'mini', icon: 'check', color: 'green' }),
        content: 'This confirms that the post includes #ad, #spon, #partner'
      }),
      !isASA && _react2.default.createElement(_semanticUiReact.Label, { size: 'mini', icon: 'minus', color: 'grey' })
    )
  );
};

InfluencerPost.propTypes = {
  post: _propTypes2.default.object.isRequired
};

var getPostTypes = exports.getPostTypes = function getPostTypes(items) {
  var isStoryValidation = function isStoryValidation(post) {
    return _lodash2.default.eq('stories', _lodash2.default.get(post, 'type')) || _lodash2.default.eq('STORY', _lodash2.default.get(post, 'trackedAsset.assetType'));
  };
  var stories = _lodash2.default.filter(items, function (post) {
    return isStoryValidation(post);
  });
  var posts = _lodash2.default.reject(items, function (post) {
    return isStoryValidation(post);
  });
  return {
    stories: _lodash2.default.size(stories),
    posts: _lodash2.default.size(posts)
  };
};

var getImpressions = function getImpressions(posts) {
  return _lodash2.default.sumBy(posts, function (post) {
    if (post.type === 'stories') {
      return _lodash2.default.get(post, 'attributes.latestImpressions', 0);
    }
    return _lodash2.default.get(post, 'insights.impressions', 0);
  });
};

var getEngagementsRate = exports.getEngagementsRate = function getEngagementsRate(_ref2) {
  var likes = _ref2.likes,
      comments = _ref2.comments,
      postsCount = _ref2.postsCount,
      followerCount = _ref2.followerCount;
  return (likes + comments) / postsCount / followerCount * 100;
};

var getJLEngagementsRate = exports.getJLEngagementsRate = function getJLEngagementsRate(_ref3) {
  var likes = _ref3.likes,
      comments = _ref3.comments,
      impressions = _ref3.impressions;
  return (likes + comments) / impressions * 100;
};

var getGiftaEngagementsRate = exports.getGiftaEngagementsRate = function getGiftaEngagementsRate(_ref4) {
  var likes = _ref4.likes,
      comments = _ref4.comments,
      followerCount = _ref4.followerCount;
  return (likes + comments) / followerCount * 100;
};

var getReach = function getReach(posts) {
  return _lodash2.default.sumBy(posts, function (post) {
    if (post.type === 'stories') {
      return _lodash2.default.get(post, 'attributes.latestReach', 0);
    }
    return _lodash2.default.get(post, 'insights.reach', 0);
  });
};

var InfluencerReportCard = function InfluencerReportCard(props) {
  var _props$value = props.value,
      values = _props$value.values,
      handle = _props$value.handle;
  var posts = values.posts,
      totals = values.totals,
      profilePic = values.profilePic;

  var totalImpressions = totals.impressions || getImpressions(posts);
  var totalReach = totals.reach || getReach(posts);
  var postTypes = getPostTypes(posts);

  var engagementsRate = getEngagementsRate({
    likes: totals.likes,
    comments: totals.comments,
    postsCount: postTypes.posts,
    followerCount: totals.followersCount
  });

  return _react2.default.createElement(
    _semanticUiReact.Card,
    { fluid: true, color: 'green' },
    _react2.default.createElement(
      _semanticUiReact.Card.Content,
      { style: { backgroundColor: '#eee' } },
      _react2.default.createElement(
        'div',
        { style: { textAlign: 'center' } },
        profilePic && _react2.default.createElement(_semanticUiReact.Image, {
          circular: true,
          size: 'tiny',
          src: profilePic
        }),
        _react2.default.createElement(
          'h3',
          { style: paddingTopTen },
          handle
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram', color: 'pink' }),
          (0, _formatting.commaFormatted)(totals.followersCount),
          ' followers'
        )
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Card.Content,
      null,
      _react2.default.createElement(
        _semanticUiReact.Grid,
        { fluid: true, textAlign: 'center', columns: 2, style: gridStyle, divided: true },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
            'posts',
            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
            _react2.default.createElement(IGValue, { value: (0, _formatting.commaFormatted)(postTypes.posts) })
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'instagram' }),
            'stories',
            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
            _react2.default.createElement(IGValue, { value: (0, _formatting.commaFormatted)(postTypes.stories) })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'like' }),
            'likes',
            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
            _react2.default.createElement(IGValue, { value: (0, _formatting.commaFormatted)(totals.likes) })
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'comment' }),
            'comments',
            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
            _react2.default.createElement(IGValue, { value: (0, _formatting.commaFormatted)(totals.comments) })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'video play outline' }),
            'views',
            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
            _react2.default.createElement(IGValue, { value: (0, _formatting.commaFormatted)(totals.views) })
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'percent' }),
            'eng. rate',
            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
            _react2.default.createElement(IGValue, { value: '' + (engagementsRate ? (0, _formatting.percentFormatted)(engagementsRate) + ' %' : '-') })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'line graph' }),
            'reach',
            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
            _react2.default.createElement(IGValue, { value: (0, _formatting.commaFormatted)(totalReach) })
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'eye' }),
            'imps',
            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true }),
            _react2.default.createElement(IGValue, { value: (0, _formatting.commaFormatted)(totalImpressions) })
          )
        )
      )
    )
  );
};

InfluencerReportCard.propTypes = {
  value: _propTypes2.default.object.isRequired
};

exports.default = InfluencerReportCard;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/reports/influencer-report-card/index.js
 ** module id = 2593
 ** module chunks = 0
 **/